module.exports = __webpack_public_path__ + "img/music.872a01f0.png";